<script setup>
import { useI18n } from 'vue-i18n'
import { computed, onMounted, ref } from 'vue'
import BusinessHours from '@/components/service_provider/business_hours.vue'

const props = defineProps({
  serviceProvider: {
    type: Object
  }
})

// I18n
const { t } = useI18n()

// Variables
const websiteDomain = computed(() => new URL(props.serviceProvider.attributes.website).hostname)

onMounted(async () => {

})

</script>

<template>
  <div class="h-full w-full">
    <div class="h-full flex flex-col">
      <div class="flex-none w-full h-24 bg-[url('/src/assets/images/service-center-standards.jpg')] bg-center bg-cover rounded-tr-lg"></div>
      <div class="p-8 grow overflow-y-auto flex flex-col gap-2">
        <h2 class="text-2xl font-semibold">{{ serviceProvider.attributes.name }}</h2>
        <address class="">
          {{ serviceProvider.attributes.street_address }}<br />
          {{ serviceProvider.attributes.city }}, {{ serviceProvider.state?.attributes?.abbreviation }}, {{ serviceProvider.attributes.zip_code }}
        </address>
        <div class="flex">
          <p class="w-16">Tel:</p>
          <a class="underline text-[#386196] hover:text-[#3a358c]" :href="`tel:${serviceProvider.attributes.phone_number_raw }`">
            {{ serviceProvider.attributes.phone_number_formatted }}
          </a>
        </div>
        <div class="flex" v-if="serviceProvider.attributes.website">
          <p class="w-16">Web:</p>
          <a class="underline text-[#386196] hover:text-[#3a358c]" :href="serviceProvider.attributes.website">
            {{ websiteDomain }}
          </a>
        </div>
        <BusinessHours :service-provider="serviceProvider" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
